import type { NavLink, SocialLink } from '../types/content'
import { assets, contactEmail } from './assets'

export const navLinks: NavLink[] = [
  { label: 'Services', href: '#services' },
  { label: 'Work', href: '#work' },
  { label: 'Blog', href: '#blog' },
  { label: 'About', href: '#about' },
  { label: 'Contact', href: `mailto:${contactEmail}` },
]

export const footerLinks: NavLink[] = [
  { label: 'Home', href: '#top' },
  { label: 'Blog', href: '#blog' },
  { label: 'Services', href: '#services' },
  { label: 'About', href: '#about' },
  { label: 'Work', href: '#work' },
  { label: 'Calendly', href: 'https://calendly.com/juliusbranding/strategy', external: true },
  { label: 'Contact', href: `mailto:${contactEmail}` },
]

export const legalLinks: NavLink[] = [
  { label: 'Imprint', href: '#' },
  { label: 'Data policy', href: '#' },
  { label: 'Cookie Policy', href: '#' },
]

export const socialLinks: SocialLink[] = [
  { label: 'X (Twitter)', href: 'https://twitter.com/ImmersivStudios', icon: assets.icons.x, scale: 'smaller' },
  { label: 'YouTube', href: 'https://www.youtube.com/@Immersive-Studios', icon: assets.icons.youtube, scale: 'normal' },
  { label: 'LinkedIn', href: 'https://www.linkedin.com/company/immersivstudios/', icon: assets.icons.linkedin, scale: 'smaller' },
  { label: 'Discord', href: 'https://discord.com/invite/6EHbhmXx3K', icon: assets.icons.discord, scale: 'smaller' },
  { label: 'Awwwards', href: 'https://www.awwwards.com/immersivestudios/', icon: assets.icons.awwwards, scale: 'bigger' },
  { label: 'Dribbble', href: 'https://dribbble.com/immersivestudios', icon: assets.icons.dribbble, scale: 'normal' },
]
